import {ExclamationCircleOutlined, MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, Menu, Modal, message} from "antd";
import {Link} from "react-router-dom";
import {handleStoreServiceLink} from "../../../../../utils/products";
import {useGetProfileContext} from "../../../../../context/profile/profile-context";
import {useDeleteStoreServiceApi} from "../../../../../react-query-hooks/store/services/delete-store-service";

type ServiceListMenuOptionProps = {
  serviceId: number;
  currentPage: number;
  slug: string;
  tinyUrl: string;
  ordersInProgress: number;
};

export function ServiceListMenuOption({
  serviceId,
  slug,
  currentPage,
  ordersInProgress,
  tinyUrl,
}: ServiceListMenuOptionProps) {
  const deleteStoreServiceMutation = useDeleteStoreServiceApi();
  const {state: profileState} = useGetProfileContext();

  const storeServiceBookingLink = handleStoreServiceLink({
    serviceId,
    slug,
    username: profileState.profileData.username,
    tinyUrl,
    windowNav: true,
  });

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm service deletion`,
      content:
        "Are you sure you want to delete this service? This action cannot be undone.",
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText: "Delete service",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
        loading: deleteStoreServiceMutation.isLoading,
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (serviceId) {
            resolve(
              deleteStoreServiceMutation.mutate(
                {storeServiceId: serviceId, currentPage},
                {
                  onSuccess: () => {
                    message.success(
                      "The selected service has been deleted successfully!"
                    );
                  },
                }
              )
            );
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };
  const menu = (
    <Menu
      items={[
        {
          label: (
            <Link to={`/products/services/edit/${serviceId}?activeTab=insights`}>
              Sales and insights
            </Link>
          ),
          key: "0",
          // disabled: true,
        },
        {
          label: <Link to={`/products/services/edit/${serviceId}`}>Edit service</Link>,
          key: "1",
          // disabled: true,
        },
        {
          label: (
            <div
              onClick={() =>
                navigator.clipboard
                  .writeText(storeServiceBookingLink)
                  .then(() => message.success("Link copied"))
              }
            >
              Copy service link
            </div>
          ),
          key: "2",
          disabled: false,
        },
        {
          label: <div onClick={handleDeleteModal}>Delete service</div>,
          key: "3",
          disabled: ordersInProgress > 0,
          danger: true,
          title:
            ordersInProgress > 0
              ? `You cannot delete because you have ${ordersInProgress} order(s) in progress`
              : undefined,
        },
      ]}
    />
  );
  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <Button
          shape="circle"
          size="small"
          icon={<MoreOutlined />}
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
          }}
        />
      </Dropdown>
    </>
  );
}
